import { Col, Row, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { get, post } from "../../../../helper/request";
import { renderApiDomain } from "../../../../helper/renderApiDomain";

const ItemSelect = styled.div`
  box-shadow: 0 0 7px #80808033;
  padding: 12px;
  cursor: pointer;
  border-radius: 3px;
  transition: all 0.3s;
  height: 100%;
  &:hover {
    background: #1f73b7;
    color: #fff;
  }
`;
export const postSticpay = ({ amount_thb, account_trade_id }) => {
  return post(`${renderApiDomain() + "deposit/sticpay"}`, {
    amount_thb: amount_thb,
    account_trade_id: account_trade_id,
  });
};

const Sticpay = (props) => {
  // const selectIp = useSelector(({ user: { ipAddress } }) => ipAddress);

  const refSticpay = useRef(null);
  const [loading, setLoading] = useState(false);
  const [linkPay, setLinkPay] = useState(null);

  useEffect(() => {
    onFinish();
  }, []);
  const onFinish = async (el) => {
    try {
      setLoading(true);
      const payload = {
        account_trade_id: props.account.id,
        amount_thb: +props.amount,
      };
      const { data } = await postSticpay(payload);

      if (data) {
        setLoading(true);

        await Promise.all([setLinkPay(data.data.link)]).then(() => {
          refSticpay.current.click();
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Spin spinning={loading}>
      <a ref={refSticpay} href={linkPay} hidden>
        Sticpay
      </a>
    </Spin>
  );
};

export default Sticpay;
